import Colors from '@shared/assets/style/default/color';
import DeviceConfig from '@devices/config';
import LowPosterDefault from '@shared/assets/images/png/lowPosterDefault.png';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withImage from '@shared/components/utils/hoc/withImage';

interface Props {
  height: number;
  width: number;
}

const Poster = styled.img<Props>`
  background: ${Colors['background']};
  border-radius: ${20 * Screen.widthRatio}px;
  border: ${1 * Screen.widthRatio}px; solid ${Colors['border']['poster']};
  height: ${(props) => props.height * Screen.widthRatio}px;
  object-fit: ${() =>
    DeviceConfig.capabilities.image.disableFitCover ? 'unset' : 'cover'};
  position: absolute;
  width: ${(props) => props.width * Screen.widthRatio}px;
`;

Poster.defaultProps = {
  width: 230,
  height: 350,
};

export default withImage(Poster, false, LowPosterDefault);
